import { OAuthProvider } from '@seapoint/server/enums';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ComponentProps } from 'react';
import { Stack } from '../../../../../design-system/stack/stack';
import { ExcludeSendersSettingsContent } from './exclude-senders-settings-content';
import { OAuthProviderConnectionSettingsContent } from './oauth-provider-connection-settings-content';

type SettingsModalContentProps = {
  excludedSendersConfig: ComponentProps<typeof ExcludeSendersSettingsContent>;
  emailConnectionConfig: ComponentProps<typeof OAuthProviderConnectionSettingsContent>['oauthProviderConnectionConfig'];
  xeroConnectionConfig: ComponentProps<typeof OAuthProviderConnectionSettingsContent>['oauthProviderConnectionConfig'];
};

export const SettingsModalContent = ({
  excludedSendersConfig,
  emailConnectionConfig,
  xeroConnectionConfig,
}: SettingsModalContentProps) => {
  const { isLongXeroFlowLive } = useFlags<{ isLongXeroFlowLive: boolean }>();

  return (
    <Stack space={5} align="stretch">
      <h1 className="text-xl font-medium leading-6 tracking-tight text-black">Invoice Pay Setting</h1>

      {emailConnectionConfig.isConnected && (
        <ExcludeSendersSettingsContent
          isLoading={excludedSendersConfig.isLoading}
          excludedSenders={excludedSendersConfig.excludedSenders}
          onSubmit={excludedSendersConfig.onSubmit}
        />
      )}

      <OAuthProviderConnectionSettingsContent
        provider={OAuthProvider.GMAIL}
        oauthProviderConnectionConfig={emailConnectionConfig}
      />

      {!isLongXeroFlowLive && (
        <OAuthProviderConnectionSettingsContent
          provider={OAuthProvider.XERO}
          oauthProviderConnectionConfig={xeroConnectionConfig}
        />
      )}
    </Stack>
  );
};
